import { render } from "./week-outstanding.vue?vue&type=template&id=168a69b1&scoped=true"
import script from "./week-outstanding.vue?vue&type=script&lang=js"
export * from "./week-outstanding.vue?vue&type=script&lang=js"

import "./week-outstanding.vue?vue&type=style&index=0&id=168a69b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168a69b1"]])

export default __exports__